import { useI18n } from './useI18n';
import type { SupportedLang } from './I18nContext';

export function LanguageSelect() {
  const { t, lang, setLang, enabled } = useI18n();

  if (!enabled) return null;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLang(e.target.value as SupportedLang);
  };

  return (
    <div className="language-select">
      <label htmlFor="language-select" className="language-select__label">
        {t('common.language')}
      </label>
      <select
        id="language-select"
        value={lang}
        onChange={handleChange}
        className="language-select__select"
      >
        <option value="en">English</option>
        <option value="pt-pt">Português</option>
      </select>
    </div>
  );
}
